import { lazyLoadModule } from '../../helpers';

export const BILLING_STATES = [
    {
        name: 'billing-root.**',
        parent: 'root',
        url: '/',
        redirectTo: 'invoices',
        lazyLoad: lazyLoadModule(() => import('./billing.module'))
    }
];



// WEBPACK FOOTER //
// ./src/app-modules/billing-module/billing.states.js